// extracted by mini-css-extract-plugin
module.exports = {"story":"story-1Qml4AcaVFdjW1j3movKBg","card":"card-2riVUdK3zrwUYARt5l4CxT"};